<!-- content -->
@for (content of heroContent; track content.tagLine; let idx = $index) {
<section class="hero"
         [class]="{'fade-in': !firstLoad}"
         (swipeleft)="changeActiveIndexBy(-1)"
         (swiperight)="changeActiveIndexBy(1)"
         [hidden]="activeContentIndex !== idx">
  <div class="image-wrapper">
    <picture>
      <source media="(max-width:600px)" [srcset]="content.background.xs" />
      <source media="(min-width:601px)" [srcset]="content.background['gt-xs']" />
      <img [src]="content.background['gt-xs']" [alt]="content.alt" />
    </picture>
  </div>

  <div class="tag-line fx-layout-column fx-align--x-center">
    <h1 [innerHTML]="content.tagLine">
    </h1>

    <p [innerHTML]="content.paragraph">
    </p>

    <div *ngIf="content.actionButton" >
      <button mat-flat-button color="primary" [routerLink]="content.actionButton.url">
        {{ content.actionButton.text }}
      </button>
    </div>

    <div class="fx-flex-grow"> </div>

    <div class="hero-nav fx-layout-row fx-gap--8px fx-align--center-x">

      <a mat-icon-button (click)="changeActiveIndexBy(-1)">
        <mat-icon svgIcon="chevron-left"></mat-icon>
      </a>
      @for (hc of heroContent; track hc; let idx = $index) {
      <a mat-icon-button color="accent" (click)="setActiveIndex(idx)">
        <mat-icon class="circle" [svgIcon]="activeContentIndex === idx ? 'circle' : 'circle-outline'"></mat-icon>
      </a>
      }
      <a mat-icon-button (click)="changeActiveIndexBy(1)">
        <mat-icon svgIcon="chevron-right"></mat-icon>
      </a>
    </div>
  </div>
</section>
}

<section class="sub-text">
  <div>
    We sell pre cut mats and custom picture frames in any size, color and quantity.
    We also sell custom matting, backing boards, clear bags, show kits, matboard value packs and custom plexiglass.
  </div>
</section>

<mbnm-shop [maxTiles]="3" [highlightPrimary]="false" slug="shop">

</mbnm-shop>

<section class="reviews">
  <mbnm-reviews title=""></mbnm-reviews>
</section>
<!-- // content -->
